import { createReducer, on } from '@ngrx/store';
import {
  loadCustodianList,
  loadCustodianListSuccess,
  loadCustodianListFailure,
  clearCustodianList,
} from './custodian.actions';

export interface CustodianState {
  data: any[] | null;
  loading: boolean;
  error: any;
}

export const initialState: CustodianState = {
  data: null,
  loading: false,
  error: null,
};

export const custodianReducer = createReducer(
  initialState,
  on(loadCustodianList, (state) => ({ ...state, loading: true, error: null })),
  on(loadCustodianListSuccess, (state, { data }) => ({ ...state, loading: false, data })),
  on(loadCustodianListFailure, (state, { error }) => ({ ...state, loading: false, error })),
  on(clearCustodianList, (state) => ({ ...state, data: null }))
);
